<div class="fix-container">
  <div class="d-flex fd-col w-100 navbar">

    <div class="d-flex jc-sb">

      <div class="d-flex">
        <div class="header-container first-container">
          <div class="logo-container">
            <a (click)="toggleMenuVisibility()" *ngIf="isMobileSize && authService.isAuthenticated()"
              class="sidebar-toggle">
              <i class="isax icon-menu-1"></i>
            </a>
            <a class="logo" (click)="goToHomePage()">
              <img class="logo-one" src="../../../assets/img/Component 1 1.svg" />
              <img class="logo-two" src="../../../assets/img/Group 26540 1.svg" />
            </a>
          </div>
        </div>
        <div class="bottom-header h-100">
          <div class="header-link h-100 ai-c menu-container">
            <!-- <button nbButton status="control" class="header-button-link header-link-hover h-100"
              (click)="gotoPage('petition/')">
              <p class="paragraph-style">دادخواست‌ها</p>
            </button> -->
            <div class="dropdown">

              <div class="dropbtn" (click)="gotoPage('petition')">دادخواست‌ها
                <nb-icon pack="fontawesome" class="fal fa-angle-down icon-style"></nb-icon>
              </div>
              <div class="dropdown-one">
                <div class="dItem" id="ready" (click)="gotoPage('petition/ready')">دادخواست آماده</div>
                <div class="dItem" id="custom" (click)="gotoPage('petition/custom')">سفارش دادخواست</div>
                <div class="dItem" id="custom" (click)="gotoPage('petition/smart')">دادخواست هوشمند</div>
              </div>
            </div>
            <!-- <button nbButton status="control" class="header-button-link header-link-hover h-100"
                (click)="gotoPage('contract/')">
                <p class="paragraph-style">قراردادها</p>
              </button> -->
            <div class="dropdown">
              <div class="dropbtn" (click)="gotoPage('contract')">قراردادها
                <nb-icon pack="fontawesome" class="fal fa-angle-down icon-style"></nb-icon>
              </div>
              <div class="dropdown-one">
                <div class="dItem" id="ready" (click)="gotoPage('contract/ready')">قرارداد آماده</div>
                <div class="dItem" id="custom" (click)="gotoPage('contract/custom')">سفارش قرارداد</div>
                <div class="dItem" id="smart" (click)="gotoPage('contract/smart')">قرارداد هوشمند</div>
                <div class="dItem" id="expertise" (click)="gotoPagePanel('contract-user/create-expertise-contract')">
                  کارشناسی
                  قرارداد</div>
                <div class="dItem paragraph-style" id="meeting"
                  (click)="gotoPagePanel('contract-user/create-contract-meeting')">حضور در جلسه
                  قرارداد</div>
              </div>
            </div>
            <!-- <button nbButton status="control" class="header-button-link header-link-hover h-100"
                (click)="gotoPage('complaint/')">
                <p class="paragraph-style">شکوائیه‌ها</p>
              </button> -->
            <div class="dropdown">
              <div class="dropbtn" (click)="gotoPage('complaint')">شکوائیه‌ها
                <nb-icon pack="fontawesome" class="fal fa-angle-down icon-style"></nb-icon>
              </div>
              <div class="dropdown-one">
                <div class="dItem" (click)="gotoPage('complaint/ready')">شکوائیه آماده</div>
                <div class="dItem" (click)="gotoPage('complaint/custom')">سفارش شکوائیه</div>
                <div class="dItem" (click)="gotoPage('complaint/smart')">شکوائیه هوشمند</div>

              </div>
            </div>
            <div class="dropdown">
              <div class="dropbtn" (click)="gotoPage('judicial')">اوراق قضایی
                <!-- <nb-icon pack="fontawesome" class="fal fa-angle-down icon-style"></nb-icon> -->
              </div>
              <!-- <div class="dropdown-one">
                <div class="dItem" (click)="gotoPagePanel('judicial-user/create-bill')">تنظیم یا کارشناسی لایحه</div>
                <div class="dItem" (click)="gotoPagePanel('judicial-user/create-declaration')">تنظیم یا کارشناسی
                  اظهارنامه</div>
                <div class="dItem" (click)="gotoPagePanel('judicial-user/create-other-request')">سایر درخواست‌ها</div>
              </div> -->
            </div>
            <div class="dropdown responsive-hidden">
              <div class="dropbtn">
                <p class="paragraph-style">خدمات حقوقی</p>
                <nb-icon pack="fontawesome" class="fal fa-angle-down icon-style"></nb-icon>
              </div>
              <div class="dropdown-one">
                <div class="dItem" (click)="gotoPage('consultation')">مشاوره</div>
                <div class="dItem" (click)="gotoPage('edu-list')">آموزش</div>
                <div class="dItem" (click)="gotoPagePanel('package-user/create-package')">بسته حقوقی</div>
              </div>
            </div>
            <button nbButton status="control" class="header-button-link hidden-mobile header-link-hover h-100"
              (click)="gotoPage('consultation')">
              <p class="paragraph-style"> مشاوره</p>
            </button>
            <button nbButton status="control" class="header-button-link hidden-mobile header-link-hover h-100"
              (click)="gotoPage('edu-list')">
              <p class="paragraph-style">آموزش</p>
            </button>
            <button nbButton status="control" class="header-button-link hidden-mobile header-link-hover h-100"
              (click)="gotoPagePanel('package-user/create-package')">
              <p class="paragraph-style">بسته حقوقی</p>
            </button>
            <button nbButton status="control" class="header-button-link header-link-hover h-100"
              (click)="gotoPagePanel('tutorial')">
              <p class="paragraph-style">راهنمای سامانه</p>
            </button>

            <button nbButton status="control" class="header-button-link header-link-hover h-100"
              (click)="goToContactUs()">
              <p class="paragraph-style">ارتباط با ما</p>
            </button>
          </div>
        </div>
      </div>




      <div class="header-container last-container" clickOutside (clickOutside)="clickedOutside()">

        <div class="search">
          <input nbInput class="search-input" *ngIf="isSearch" [(ngModel)]="searchText" (input)="loadsearch()"
            [nbAutocomplete]="auto" (keyup.enter)="loadsearch(true)" placeholder="جستجو">
          <nb-autocomplete #auto>
            <nb-option *ngFor="let result of result | slice:0:5">
              <div class="result" (click)="goToSearchPage(result.slug, result.type)">
                <div class="img-title">
                  <img [src]="result?.image?.url" [alt]="result?.image?.alt" class="result-image">
                  <p class="result-title">
                    {{ result.title }}
                  </p>
                </div>
                <!-- <p class="result-type">
                  {{ result.translatedType }}
                </p> -->
              </div>
            </nb-option>
            <nb-option *ngIf="searchPage > 1" class="show-more-result">
              <div (click)="showMoreResult(searchText)">مشاهده بیشتر</div>
            </nb-option>
          </nb-autocomplete>
        </div>


        <div class="search-responsive" [ngClass]="{'search-responsive-show' : isSearchResponsive}">
          <div class="search-header d-flex px-5 py-3">
            <div class="exit-search" (click)="isSearchResponsive = false"><i class="fal fa-times"></i></div>
            <p class="search-font">جستجو در دادگام</p>
          </div>
          <div class="input-responsive mx-5 mt-3">
            <div class="input">

              <nb-form-field>
                <input nbInput fullWidth type="search" class="w-100 search-input-responsive" [(ngModel)]="searchText"
                  (input)="loadsearch()" [nbAutocomplete]="auto2" (keyup.enter)="loadsearch(true)" placeholder="جستجو">
                <div nbPrefix ghost>
                  <nb-icon pack="fontawesome" class="fal fa-search icon-search"></nb-icon>
                </div>
              </nb-form-field>

            </div>
          </div>

          <div *ngIf="result.length >= 3" class="result-font px-5 mt-4">نتایج جستجو</div>
          <nb-autocomplete #auto2>
            <nb-option *ngFor="let result of result">
              <div class="search-body-mobile" (click)="goToSearchPage(result.slug, result.type)">
                <div class="image-result">
                  <img [src]="result.image?.url" [alt]="result?.image?.alt" class="img-result">
                </div>

                <p class="search-body-font">{{result.title}}</p>
                <div class="search-body-icon">
                  <nb-icon pack="fontawesome" class="fal fa-angle-left last"></nb-icon>
                </div>
              </div>
            </nb-option>
            <nb-option *ngIf="searchPage > 1" class="show-more-result">
              <div (click)="showMoreResult(searchText)">مشاهده بیشتر</div>
            </nb-option>
          </nb-autocomplete>
          <div class="popular px-5 mt-4" *ngIf="result.length <= 2">
            <div class="popular-header">
              <div class="popular-icon">
                <nb-icon pack="fontawesome" class="fal fa-fire"></nb-icon>
              </div>
              <p class="popular-font">جستجو های پرطرفدار</p>
            </div>
            <div class="popular-body mt-4">
              <a class="popular-item" *ngFor="let item of popularItems" [href]="item.link">
                {{item.title}}
              </a>
            </div>
          </div>
        </div>



        <button nbButton ghost status="primary" id="serchBtn" (click)="openSearch()" class="search-btn">
          <!-- <img src="../../../assets/img/search.svg" /> -->
          <nb-icon pack="fontawesome" class="fal fa-search icon-search"></nb-icon>
        </button>



        <div class="bell-notifcation" (click)="openNotification()" *ngIf="authService.isAuthenticated()" clickOutside
          (clickOutside)="clickedOutside('notification-container')">
          <button nbButton ghost status="primary" class="bill">
            <nb-badge *ngIf="env.totalNotif" text="{{env.totalNotif > 99 ? '99+' : env.totalNotif}}"
              position="top right" class="unread-number" status="primary">

            </nb-badge>
            <nb-icon pack="fontawesome" class="fal fa-bell bell-icon"></nb-icon>
          </button>
        </div>


        <div class="notification-container rounded border" *ngIf="isNotification">
          <div class="unread-message px-2">
            <p class="font">اطلاع رسانی</p>
            <!-- <div clas="unread">
              <p class="unread-font"><span>{{env.unreadNotificationsCount}}</span> پیام خوانده نشده</p>
            </div> -->
          </div>

          <ng-container *ngIf="env.totalNotif">
            <!-- <div class="messages px-2" *ngFor="let message of env.notifications"
            (click)="gotoMessagePage('notifications/notification-detail' , message.uuid) ; isNotification = false">
            <nb-icon pack="fontawesome" class="fal fa-envelope"></nb-icon>
            <p class="font">{{message.title}}</p>
            <nb-icon pack="fontawesome" class="fal fa-angle-left last"></nb-icon>
          </div> -->
            <div class="messages" *ngIf="env.unreadNotificationsCount">
              <div class="notification-record-font" (click)="gotoPagePanel('notifications/notification-list')">
                <div>
                  <nb-icon pack="fontawesome" class="fal fa-angle-left"></nb-icon>
                </div>
                <p class="">پیام های خوانده نشده</p>
                <div class="unread-number-container">
                  <nb-badge text="{{env.unreadNotificationsCount}}" position="center" class="unread-number"
                    status="info">
                  </nb-badge>
                </div>
              </div>
            </div>

            <div class="messages" *ngIf="env.unreadmessage">
              <div class="notification-record-font" (click)="goToChat()">
                <div>
                  <nb-icon pack="fontawesome" class="fal fa-angle-left"></nb-icon>
                </div>
                <p class="">گفتوگو های خوانده نشده</p>
                <div class="unread-number-container">
                  <nb-badge text="{{env.unreadmessage}}" position="center" class="unread-number" status="info">
                  </nb-badge>
                </div>
              </div>
            </div>
            <!-- <div class="button">
            <button nbButton outline status="primary"
              (click)="gotoPagePanel('notifications/notification-list') ; isNotification = false"
              class="btn btn-primary ">مشاهده همه</button>
          </div> -->
          </ng-container>
          <ng-container *ngIf="env.totalNotif <= 0">
            <div class="no-message px-2">
              <nb-icon pack="fontawesome" class="fal fa-envelope-open"></nb-icon>
              <p>اعلانی یافت نشد.</p>
            </div>
          </ng-container>
        </div>



        <button nbButton ghost status="primary" class="personal-info p-2 mx-2" (click)="toggleSidebarVisibility()"
          *ngIf="isMobileSize && showSidebar">
          <nb-icon pack="fontawesome" class="fal fa-user icon-user"></nb-icon>
        </button>

        <nb-actions>
          <nb-action class="header-link px-0">
            <div class="notif-container">
              <div class="dir-ltr">
                <div class="cell" clickOutside (clickOutside)="clickedOutside('notification')">
                  <div class="header-title" [class.active]="showNotifications">
                    <div *ngIf="!authService.isAuthenticated()">
                      <button nbButton status="primary" (click)="gotoPagePanel('auth/login')">
                        ورود | ثبت نام
                      </button>
                    </div>
                    <div *ngIf="!isMobileSize">
                      <div class="user-menu" *ngIf="authService.isAuthenticated()" clickOutside
                        (clickOutside)="clickedOutside('logout')">
                        <button nbButton outline status="primary" class="personal-info p-2 mx-2"
                          *ngIf="!userData?.extra_data?.name" (click)="showLogOut()">
                          <!-- <img class="img ml-5" [src]="userData.avatar" /> -->
                          <nb-icon pack="fontawesome" class="	fal fa-angle-down arrow-icon"></nb-icon>
                          <p class="username">{{setUserNameFunc()}}</p>
                          <nb-icon pack="fontawesome" class="fal fa-user icon-user"></nb-icon>
                          <!-- <nb-icon pack="fontawesome" class="fal fa-2x fa-user mx-2 icon-style"></nb-icon> -->
                        </button>

                        <button nbButton outline status="primary" class="personal-info"
                          *ngIf="userData?.extra_data?.name" (click)="showLogOut()">
                          <!-- <img class="img ml-5" [src]="userData.avatar" /> -->
                          <nb-icon pack="fontawesome" class="	fal fa-angle-down arrow-icon"></nb-icon>
                          <p class="username">{{ userData?.extra_data?.name }}</p>
                          <nb-icon pack="fontawesome" class="fal fa-user icon-user"></nb-icon>
                          <!-- <nb-icon pack="fontawesome" class="fal fa-angle-down black mr-5"></nb-icon> -->
                        </button>
                        <div class="dropdown-logOut" *ngIf="logOutbutton">
                          <a nbButton ghost fullWidth class="d-flex flex-row-reverse text-start"
                            (click)="goToHomePage()">
                            <nb-icon pack="fontawesome" class="fal fa-home blue user-icon icon-style"></nb-icon>
                            <p class="gray mr-5">صفحه اصلی</p>
                          </a>

                          <a nbButton ghost fullWidth [routerLink]="['/profile/profile']"
                            (click)="clickedOutside('logout')" class="d-flex flex-row-reverse text-start">
                            <nb-icon pack="fontawesome" class="fal fa-user green user-icon icon-style"></nb-icon>
                            <p class="gray mr-5">صفحه کاربری</p>
                          </a>

                          <a nbButton ghost fullWidth [routerLink]="['/auth/logout']"
                            class="d-flex flex-row-reverse text-start">
                            <nb-icon pack="fontawesome" class="fal fa-sign-out red"></nb-icon>
                            <p class="gray mr-5">خروج از حساب</p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nb-action>
        </nb-actions>
      </div>
    </div>
  </div>
</div>